import * as React from "react";

function HeartSvg(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.517 17.342c-.283.1-.75.1-1.033 0-2.417-.825-7.817-4.267-7.817-10.1 0-2.575 2.075-4.659 4.633-4.659 1.517 0 2.859.734 3.7 1.867a4.608 4.608 0 013.7-1.867c2.559 0 4.634 2.084 4.634 4.659 0 5.833-5.4 9.275-7.817 10.1z"
        stroke="#9F9E9E"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HeartSvg;
